import { ofType } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { getLoginRequestHeader } from '../../../utils';
import { of } from 'rxjs';
import { IAction } from '../../../helpers/interfaces';
import {
    checksumReportSuccess,
    ChecksumReportTypes,
} from '../../actions/backoffice/checksum-report-actions';
import { apiError } from '../../actions/user-actions';
import axios from 'axios';
import { SERVER_URL } from '../../../utils/config';

export const checksumReportEpic = (action$: Observable<IAction>) =>
    action$.pipe(
        ofType(ChecksumReportTypes.CHECKSUM_REPORT_REQUEST),
        mergeMap((action) => {
            const params = new URLSearchParams();
            
            if (action.payload.pagingInfo) {
                params.append('pageNumber', action.payload.pagingInfo.pageNumber?.toString() || '1');
                params.append('pageSize', action.payload.pagingInfo.pageSize?.toString() || '10');
            }

            if (action.payload.algorithmType) {
                params.append('hashAlgorithm', action.payload.algorithmType);
            }

            if (action.payload.gameName) {
                params.append('gameName', action.payload.gameName);
            }

            const url = `${SERVER_URL}/game-certified-hash?${params.toString()}`;

            return from(
                axios.get(url, {
                    headers: getLoginRequestHeader('application/json'),
                }),
            ).pipe(
                map((response) => checksumReportSuccess(response.data)),
                catchError((error) =>
                    of(apiError(error, ChecksumReportTypes.CHECKSUM_REPORT_REQUEST)),
                ),
            );
        }),
    );
